/**
 * un objet de navigation
 */
export class NavigationParameter {
  public code: string; // code unique de la vue
  public name: string; // code du libellé pour traduction
  public icon: string = null; // référence de RESOURCE
  public order: number = 0; // ordre d'affichage dans le tab
  public color: string = null; // couleur d'onglet
  public width: number = 150; // taille d'onglet
  public description: string = ''; // desc dans la vue ajout de tabs
  public featureCode: string = null; // fonctionnalité correspondante (standard ou custom)

  constructor(
    pCode: string,
    pName: string,
    pFeatureCode?: string,
    pIcon?: string,
    pOrder?: number,
    pColor?: string,
    width?: number,
    description?: string
  ) {
    this.code = pCode;
    this.name = pName;
    this.icon = pIcon;
    this.order = pOrder ? pOrder : 0;
    this.color = pColor;
    this.featureCode = pFeatureCode;
    if (width) {
      this.width = width;
    }
    if (description) {
      this.description = description;
    }
  }
}
